import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Drawer, Hidden, IconButton, useTheme } from '@material-ui/core';
import { Menu as MenuIcon } from '@material-ui/icons';

import { AggregatorProvider } from 'context/AggregatorContext';

import useStyles from './styles';
import Sidebar, { SIDEBAR_WIDTH } from './Sidebar';

const COLLAPSE_STORAGE_KEY = 'layout.sidebarCollapsed';

const loadCollapsed = () => {
  try {
    return localStorage.getItem(COLLAPSE_STORAGE_KEY) === '1';
  } catch (error) {
    return false;
  }
};

/**
 * Shell del rediseño: un solo sidebar verde oscuro colapsable (236↔64px)
 * que concentra marca, selector global de agregador, navegación y cuenta.
 */
function DashboardLayout({ children }) {
  const classes = useStyles();
  const theme = useTheme();
  const location = useLocation();

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(loadCollapsed);

  const handleToggleCollapse = () => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(COLLAPSE_STORAGE_KEY, next ? '1' : '0');
      } catch (error) { /* almacenamiento no disponible */ }
      return next;
    });
  };

  // Cierra el drawer móvil al navegar
  useEffect(() => {
    setMobileNavOpen(false);
  }, [location.pathname]);

  return (
    <AggregatorProvider>
      <div className={classes.root}>
        {/* Sidebar persistente (desktop) */}
        <Hidden mdDown>
          <Sidebar
            collapsed={collapsed}
            onToggleCollapse={handleToggleCollapse}
          />
        </Hidden>

        {/* Drawer temporal (móvil) */}
        <Hidden lgUp>
          <IconButton
            onClick={() => setMobileNavOpen(true)}
            style={{
              position: 'fixed',
              top: 10,
              left: 10,
              zIndex: 1100,
              background: theme.brand.brandDark,
              color: '#fff',
              padding: 8,
            }}
          >
            <MenuIcon fontSize="small" />
          </IconButton>

          <Drawer
            anchor="left"
            open={isMobileNavOpen}
            onClose={() => setMobileNavOpen(false)}
            variant="temporary"
            PaperProps={{
              style: {
                width: SIDEBAR_WIDTH,
                border: 'none',
                background: 'transparent',
              },
            }}
          >
            <Sidebar collapsed={false} onToggleCollapse={() => setMobileNavOpen(false)} />
          </Drawer>
        </Hidden>

        <div className={collapsed ? classes.wrapperCollapsed : classes.wrapper}>
          <div className={classes.contentContainer}>
            <div
              children={children}
              className={classes.content}
            />
          </div>
        </div>
      </div>
    </AggregatorProvider>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.any,
};

export default DashboardLayout;
